interface IAuthActivateRequest {
  email: string;
  flowId: string;
}

export interface ISnActivationError {
  email?: true;
  phone?: true;
  password?: true;
}

interface IAuthActivateResponse {
  flowId: string;
}

export interface IConfirmEmailRequest {
  uid: string;
  token: string;
}

export interface IConfirmPhoneRequest extends IAuthActivateRequest {
  verificationCode: string;
}

export interface ICreatePasswordRequest extends IAuthActivateRequest {
  newPassword: string;
}

export interface IEmailConfirmResponse extends IAuthActivateResponse {
  email: string;
  mobilePhone: string;
}

export interface IConfirmPhoneResponse extends IAuthActivateResponse {}

export interface ICreatePasswordResponse extends IAuthActivateResponse {}
